<template>
	<div class="report-file-form">
		<form class="report" @submit.prevent>
			<h4 cass="report__title">Generate Report</h4>

			<AppDateRangePicker
				class="report__filter"
				placeholder="from - to"
				v-model="downloadForm.date"
				:disabled="downloadFileLoading"
				:required="true"
			>
				Select Date
			</AppDateRangePicker>

			<p
				class="clear"
				:disabled="downloadFileLoading"
			>
				<a @click.prevent="downloadForm.date = null">
					Clear
				</a>
			</p>

			<AppTimeRangePicker
				class="report__filter"
				placeholder="from - to"
				v-model="downloadForm.time"
				:disabled="downloadFileLoading"
			>
				Select Time
			</AppTimeRangePicker>

			<p
				class="clear"
				:disabled="downloadFileLoading"
			>
				<a @click.prevent="downloadForm.time = null">
					Clear
				</a>
			</p>

			<div class="report__controls">
				<AppButton
					modifier="small-primary"
					:disabled="downloadFileLoading || !isFormValid"
					@click="downloadFile('pdf')"
				>
					Generate PDF
				</AppButton>

				<AppButton
					modifier="small-secondary"
					:disabled="downloadFileLoading || !isFormValid"
					@click="downloadFile('xls')"
				>
					Download .XLS
				</AppButton>
			</div>
		</form>

		<div
			v-if="downloadFileLoading"
			class="report-file-form__loading"
		>
			<AppLoading/>
		</div>
	</div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
	// action to dispatch
	props: ['action'],

	computed: {
		...mapFields('user', [
			'downloadForm',
			'downloadFileLoading',
			'downloadFileData'
		]),

		isFormValid () {
			const { date, time } = this.downloadForm
            return date && time
		}
	},

	methods: {
		async downloadFile (type) {
			const { date, time } = this.downloadForm
			const { dateFormatter } = this.$options.filters

			const form = new FormData()

			form.append('id', this.$route.params.id)
			form.append('date_from', dateFormatter(date[0], 'YYYY-MM-DD'))
			form.append('date_to', dateFormatter(date[1], 'YYYY-MM-DD'))

			if (time) {
				const today = new Date().toDateString()
				form.append('time_from', dateFormatter(new Date(`${today}, ${time[0]}`), 'HH:mm'))
				form.append('time_to', dateFormatter(new Date(`${today}, ${time[1]}`), 'HH:mm'))
			}

			if (type === 'pdf') {
				await this.$store.dispatch(this.action, form)
				if (!this.downloadFileData) return
				localStorage.setItem('reportData', JSON.stringify(this.downloadFileData))
				window.open(`/generate-report`, '_blank')
			}

			if (type === 'xls') {
				this.$store.dispatch('user/downloadUserProfileExcel', form)
				// console.log('download xls')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.report-file-form {
	position: relative;

	.report {
		padding: .6em;
		border: 1px dashed lighten($default-light, 10%);
		margin-bottom: 1.5em;

		&__controls {
			display: flex;
			justify-content: space-between;
			margin: 10px 0;

			> * { width: 48%; }
		}

		&__filter {
			margin: .5em 0;
		}

		.clear {
			text-align: right;
			border: none;
			background: none;
			font-size: .9em;

			a {
				text-decoration: none;
				color: $danger;
			}
		}
	}

	&__loading {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		background-color: #ffffff77;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
